<template>
  <v-navigation-drawer
    right
    app
    fixed
    temporary
    permanent
    :width="drawerWidth + 'vw'"
    height="93vh"
    style="top: 65px"
  >
    <!-- Draggable border -->
    <div v-if="!isMobile" class="resizer" @mousedown="startResize()"></div>
    <v-row>
      <v-col cols="auto">
        <v-icon @click="closePanel()" class="mx-2">mdi-close</v-icon>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="auto">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" @click="goTo()">mdi-arrow-top-right</v-icon>
          </template>
          <span> Go To </span>
        </v-tooltip>
      </v-col>
    </v-row>
    <component
      :is="activeComponent"
      :isSidebar="true"
      :schoolId="schoolId"
      :clientId="clientId"
      :districtAdminId="districtAdminId"
      :providerId="providerId"
    />
  </v-navigation-drawer>
</template>

<script>
import SchoolForm from "../Client/Schools/school-form.vue";
import ClientDetails from "../Client/Details/client-details.vue";
import DistrictAdminForm from "../Client/DistrictAdmins/district-admin-form.vue";
import ProviderForm from "../Providers/provider-form.vue";

export default {
  data() {
    return {
      drawerWidth: 50, // Default width
      minWidth: 25,
      maxWidth: 95,
    };
  },
  props: [
    "schoolId",
    "clientId",
    "districtAdminId",
    "providerId",
    "activeComponent",
  ],
  components: {
    SchoolForm,
    ClientDetails,
    DistrictAdminForm,
    ProviderForm,
  },
  mounted() {
    this.drawerWidth = this.isMobile ? 100 : 50;
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.mobile;
    },
  },
  methods: {
    closePanel() {
      this.$emit("closePanel");
    },
    goTo() {
      this.$router.push({
        name: this.activeComponent,
        params: {
          clientId: this.clientId,
          schoolId: this.schoolId,
          districtAdminId: this.districtAdminId,
          providerId: this.providerId,
        },
      });
    },
    throttle(fn, wait) {
      let throttled = false;
      return function (...args) {
        if (!throttled) {
          fn.apply(this, args);
          throttled = true;
          setTimeout(() => {
            throttled = false;
          }, wait);
        }
      };
    },
    startResize() {
      document.getElementById("app").classList.toggle("moving", true);
      window.addEventListener("mousemove", this.resizeWrapper);
      window.addEventListener("mouseup", this.stopResize);
    },
    resizeWrapper: function (e) {
      this.throttle(this.resize(e), 500);
    },
    resize(e) {
      // resized width (pixels)
      var elementWidth = document.body.scrollWidth - e.clientX;
      // caluclate view-width percentage based on element width and window width
      var vw = (elementWidth / window.innerWidth) * 100;
      // if resizing outside the min/max width, then stop resize
      if (
        (this.drawerWidth > vw && vw < this.minWidth) ||
        (this.drawerWidth < vw && vw > this.maxWidth)
      ) {
        this.stopResize();
      }
      // resize to the new view-width without exceeding the min/max width
      this.drawerWidth = Math.max(Math.min(vw, this.maxWidth), this.minWidth);
      // because of the throttle - ensure the width didn't go below min width
      if (this.drawerWidth == this.minWidth) {
        this.drawerWidth += 5;
      }
    },
    stopResize() {
      document.getElementById("app").classList.toggle("moving", false);
      window.removeEventListener("mouseup", this.stopResize);
      window.removeEventListener("mousemove", this.resizeWrapper);
    },
  },
};
</script>

<style>
.resizer {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  width: 5px;
  cursor: ew-resize;
  background-color: transparent;
  z-index: 100;
}
.resizer:hover {
  background-color: rgba(0, 0, 0, 0.3);
}
.moving {
  user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
}
</style>